import { useQuery } from '@tanstack/react-query';

import { useAvApi } from '@app-velocity/av-api-v2';

import { getReportConfigQueryKey } from './query-key';

export const useGetScopedReportConfigQuery = (
  scope?: 'WEBSITE' | 'FIGMA_PROTOTYPE',
  workspaceId?: string,
  prototypeId?: string,
  enabled = true
) => {
  const {
    prototypeReportMetricConfig,
    projectReportMetricConfig,
    uRLPrototypeReportMetricConfig,
  } = useAvApi();

  return useQuery({
    enabled: enabled && !!workspaceId && !!scope,
    queryKey: getReportConfigQueryKey(scope!, workspaceId, prototypeId),
    queryFn: async () => {
      if (!workspaceId || !scope) return;

      if (!prototypeId) {
        const response =
          await projectReportMetricConfig.getV2ProjectsReportConfigByProjectId(
            { projectId: workspaceId },
            { scope }
          );

        return response.data;
      }

      if (scope === 'FIGMA_PROTOTYPE') {
        const response =
          await prototypeReportMetricConfig.getV2ProjectsPrototypesReportConfigByProjectIdAndPrototypeId(
            { projectId: workspaceId, prototypeId }
          );

        return response.data;
      }

      const response =
        await uRLPrototypeReportMetricConfig.getV2ProjectsUrlPrototypesReportConfigByProjectIdAndPrototypeId(
          { projectId: workspaceId, prototypeId }
        );

      return response.data;
    },
    staleTime: 60000,
  });
};
